/* =============================================================
   RIMETRY PLANNING — Theme JavaScript
   ============================================================= */
(function () {
  'use strict';

  // ---------------------------------------------------------
  // Utility: format money following shop.money_format
  // ---------------------------------------------------------
  function formatMoney(cents) {
    var n = Math.round(cents);
    var formatted = '¥' + n.toLocaleString('ja-JP');
    return formatted;
  }

  // ---------------------------------------------------------
  // METER INPUT (0.1m increments, min 0.5m by default)
  // <div data-meter-input data-min="0.5" data-step="0.1">
  //   <button data-meter-dec>−</button>
  //   <input data-meter-field value="1.0">
  //   <button data-meter-inc>+</button>
  // </div>
  // ---------------------------------------------------------
  function initMeterInputs() {
    document.querySelectorAll('[data-meter-input]').forEach(function (root) {
      var field = root.querySelector('[data-meter-field]');
      var dec = root.querySelector('[data-meter-dec]');
      var inc = root.querySelector('[data-meter-inc]');
      var min = parseFloat(root.dataset.min || '0.5');
      var step = parseFloat(root.dataset.step || '0.1');

      function clamp(v) {
        if (isNaN(v) || v < min) return min;
        return Math.round(v * 10) / 10;
      }

      function setValue(v, fire) {
        field.value = clamp(v).toFixed(1);
        if (fire !== false) {
          field.dispatchEvent(new CustomEvent('meter:change', { bubbles: true, detail: { value: parseFloat(field.value) } }));
        }
      }

      dec && dec.addEventListener('click', function () { setValue(parseFloat(field.value) - step); });
      inc && inc.addEventListener('click', function () { setValue(parseFloat(field.value) + step); });
      field && field.addEventListener('blur', function () { setValue(parseFloat(field.value)); });
      field && field.addEventListener('change', function () { setValue(parseFloat(field.value)); });
    });
  }

  // ---------------------------------------------------------
  // METER CALCULATOR
  // <div data-meter-calc data-required='{"suit":{"S":3.0,...},...}'>
  //   <div data-meter-opts="garment">
  //     <button data-value="suit">Suit</button>...
  //   </div>
  //   <div data-meter-opts="size">
  //     <button data-value="S">S</button>...
  //   </div>
  //   <span data-meter-result>2.2</span>
  // </div>
  // ---------------------------------------------------------
  function initMeterCalculator() {
    document.querySelectorAll('[data-meter-calc]').forEach(function (calc) {
      var requiredData = {};
      try {
        requiredData = JSON.parse(calc.dataset.required || '{}');
      } catch (e) {
        console.warn('[RIMETRY] Invalid meter-calc data:', e);
      }

      var resultEl = calc.querySelector('[data-meter-result]');
      var resultMetaEl = calc.querySelector('[data-meter-result-meta]');
      var targetInput = document.querySelector(calc.dataset.targetInput || '[data-meter-field]');

      // current selection
      var state = {
        garment: calc.querySelector('[data-meter-opts="garment"] [aria-pressed="true"]')
      };
      state.garment = state.garment ? state.garment.dataset.value : null;

      function recompute() {
        if (!state.garment) {
          // 用途未選択時は表示そのまま
          if (resultEl) resultEl.textContent = '—';
          if (resultMetaEl) resultMetaEl.textContent = '用途を選択';
          return;
        }
        var meters = requiredData[state.garment];
        if (typeof meters !== 'number') return;
        if (resultEl) resultEl.textContent = meters.toFixed(1);
        if (resultMetaEl) resultMetaEl.textContent = state.garment.toUpperCase();
        if (targetInput) {
          targetInput.value = meters.toFixed(1);
          targetInput.dispatchEvent(new CustomEvent('meter:change', { bubbles: true, detail: { value: meters } }));
        }
      }

      function bindOptGroup(name, key) {
        var group = calc.querySelector('[data-meter-opts="' + name + '"]');
        if (!group) return;
        group.querySelectorAll('button[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            state[key] = btn.dataset.value;
            recompute();
          });
        });
      }

      bindOptGroup('garment', 'garment');
      bindOptGroup('size', 'size');
      recompute();
    });
  }

  // ---------------------------------------------------------
  // SUBTOTAL UPDATER on product page
  // unit = 10cm unit price (例: ¥920)
  // meters = 数量(メートル)、例: 2.2
  // → 計算: unit × (meters × 10)  例: 920 × 22 = ¥20,240
  // ---------------------------------------------------------
  function initSubtotal() {
    document.querySelectorAll('[data-subtotal]').forEach(function (out) {
      var unit = parseFloat(out.dataset.unitPrice || '0');
      function update(meters) {
        var qty = Math.round(meters * 10);  // メートル → 10cm個数
        out.textContent = formatMoney(unit * qty);
      }
      var field = document.querySelector('[data-meter-field]');
      if (!field) return;
      field.addEventListener('meter:change', function (e) { update(e.detail.value); });
      update(parseFloat(field.value) || 0);
    });
  }

  // ---------------------------------------------------------
  // PRODUCT FORM (Add to cart with line-item quantity in 0.1m)
  // We store the meters as line item property AND use integer qty.
  // Internally: quantity = round(meters * 10), price displayed = unit/m * meters
  // ---------------------------------------------------------
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var field = form.querySelector('[data-meter-field]');
      var hiddenQty = form.querySelector('input[name="quantity"]');
      var hiddenMeters = form.querySelector('input[name="properties[Meters]"]');
      if (!field || !hiddenQty) return;
      var meters = parseFloat(field.value) || 0.5;
      // assumption: variant price is set per 0.1m
      // → cart line qty in Shopify = meters * 10
      hiddenQty.value = Math.round(meters * 10);
      if (hiddenMeters) hiddenMeters.value = meters.toFixed(1) + 'm';
    });
  }

  // ---------------------------------------------------------
  // TABS (Specifications / Story / Care / Shipping)
  // ---------------------------------------------------------
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tab;
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.dataset.tabPanel !== target; });
        });
      });
    });
  }

  // ---------------------------------------------------------
  // PRODUCT GALLERY (thumbnail + arrow navigation + keyboard)
  // ---------------------------------------------------------
  function initProductGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    var images = main.querySelectorAll('.product-gallery__img');
    var thumbs = document.querySelectorAll('[data-media-target]');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    var counterEl = document.querySelector('[data-gallery-current]');

    if (images.length === 0) return;
    var currentIndex = 0;

    function setActive(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;

      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      if (counterEl) counterEl.textContent = (index + 1).toString();
    }

    // Thumbnail click
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setActive(i);
      });
    });

    // Arrow buttons
    prevBtn && prevBtn.addEventListener('click', function () {
      setActive(currentIndex - 1);
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      setActive(currentIndex + 1);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      // Only when not focused on input/textarea
      if (e.target.matches('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') setActive(currentIndex - 1);
      if (e.key === 'ArrowRight') setActive(currentIndex + 1);
    });
  }

  // ---------------------------------------------------------
  // LIGHTBOX (full-screen image viewer with zoom)
  // ---------------------------------------------------------
  function initLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var images = lightbox.querySelectorAll('[data-lightbox-img]');
    var triggers = document.querySelectorAll('[data-lightbox-trigger]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var counterEl = lightbox.querySelector('[data-lightbox-current]');
    var hintEl = lightbox.querySelector('[data-lightbox-hint]');

    if (images.length === 0) return;

    var currentIndex = 0;
    var isZoomed = false;
    var dragState = { isDragging: false, startX: 0, startY: 0, offsetX: 0, offsetY: 0 };

    function open(index) {
      currentIndex = index || 0;
      setActive(currentIndex);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
    }

    function close() {
      resetZoom();
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
    }

    function setActive(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      resetZoom();
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      if (counterEl) counterEl.textContent = (index + 1).toString();
    }

    function resetZoom() {
      isZoomed = false;
      images.forEach(function (img) {
        img.classList.remove('is-zoomed', 'is-dragging');
        img.style.transform = '';
      });
      dragState.offsetX = 0;
      dragState.offsetY = 0;
      if (hintEl) hintEl.textContent = 'クリックでズーム / ESCで閉じる';
    }

    function toggleZoom(e) {
      var activeImg = lightbox.querySelector('.lightbox__img.is-active');
      if (!activeImg) return;
      isZoomed = !isZoomed;
      if (isZoomed) {
        activeImg.classList.add('is-zoomed');
        dragState.offsetX = 0;
        dragState.offsetY = 0;
        if (hintEl) hintEl.textContent = 'ドラッグで移動 / 再クリックで縮小';
      } else {
        activeImg.classList.remove('is-zoomed', 'is-dragging');
        activeImg.style.transform = '';
        if (hintEl) hintEl.textContent = 'クリックでズーム / ESCで閉じる';
      }
    }

    function onDragStart(e) {
      var activeImg = lightbox.querySelector('.lightbox__img.is-active');
      if (!activeImg || !isZoomed) return;
      e.preventDefault();
      dragState.isDragging = true;
      dragState.startX = (e.clientX || e.touches[0].clientX) - dragState.offsetX;
      dragState.startY = (e.clientY || e.touches[0].clientY) - dragState.offsetY;
      activeImg.classList.add('is-dragging');
    }

    function onDragMove(e) {
      if (!dragState.isDragging) return;
      var activeImg = lightbox.querySelector('.lightbox__img.is-active');
      if (!activeImg) return;
      e.preventDefault();
      var clientX = e.clientX || (e.touches && e.touches[0].clientX);
      var clientY = e.clientY || (e.touches && e.touches[0].clientY);
      if (clientX === undefined) return;
      dragState.offsetX = clientX - dragState.startX;
      dragState.offsetY = clientY - dragState.startY;
      activeImg.style.transform = 'scale(2) translate(' + (dragState.offsetX / 2) + 'px, ' + (dragState.offsetY / 2) + 'px)';
    }

    function onDragEnd() {
      if (!dragState.isDragging) return;
      dragState.isDragging = false;
      var activeImg = lightbox.querySelector('.lightbox__img.is-active');
      if (activeImg) activeImg.classList.remove('is-dragging');
    }

    // Triggers (gallery main image)
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = parseInt(trigger.dataset.mediaIndex || '0', 10);
        open(index);
      });
    });

    // Close
    closeBtn && closeBtn.addEventListener('click', close);

    // Background click to close (but not when clicking image or controls)
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === stage) close();
    });

    // Navigation
    prevBtn && prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setActive(currentIndex - 1);
    });
    nextBtn && nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setActive(currentIndex + 1);
    });

    // Image click — zoom toggle
    images.forEach(function (img) {
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleZoom(e);
      });
      // Mouse drag
      img.addEventListener('mousedown', onDragStart);
      // Touch drag
      img.addEventListener('touchstart', onDragStart, { passive: false });
    });

    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove, { passive: false });
    document.addEventListener('touchend', onDragEnd);

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') setActive(currentIndex - 1);
      if (e.key === 'ArrowRight') setActive(currentIndex + 1);
    });
  }

  // ---------------------------------------------------------
  // INIT
  // ---------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    initMeterInputs();
    initMeterCalculator();
    initSubtotal();
    initProductForm();
    initTabs();
    initProductGallery();
    initLightbox();
  });
})();
